import {Box, Tabs, Tab} from "@mui/material";
import * as React from 'react';
import TabPanel from "../../../../share/components/tab/TabPanel";
import { Location } from "../../../types/models/Location";
import LocationListItem from "../../../../location/components/location/LocationList/LocationListItem";
import TimberStorageListItem from "../../../../timber/components/timberStorage/TimberStorageList/TimberStorageListItem";
import ShipmentListItem from "../../../../timber/components/shipment/ShipmentList/ShipmentListItem";
import {useStateSession} from "../../../../hooks/useAuth";
import { t } from "@lingui/core/macro";

type IFormProps = {
    data: Location;
};

const LocationTabs: React.FC<IFormProps> = ({ data = {} }) => {

    const session = useStateSession()
    const searchParams = new URLSearchParams(window.location.search)

    const [tabValue, setTabValue] = React.useState(searchParams.get('tab') || 'location');
    const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
        
        if (searchParams.has('tab')) {
            searchParams.set('tab', newValue)
        } else {
            searchParams.append('tab', newValue)
        }
        window.history.pushState({}, '', '?' + searchParams.toString())

        setTabValue(newValue);
    };

    return (
        <Box sx={ { width: '100%' } }>
            <Tabs
                value={tabValue}
                onChange={handleTabChange}
                variant="scrollable"
                scrollButtons="auto"
                data-testid="Location-tabs"
            >
                { session.hasPermission('', 'applications/location/entities/Locations/list/view') &&
                    <Tab label={t`Locations`} value="location"/>
                }
                { session.hasPermission('', 'applications/location/entities/TimberStorages/list/view') &&
                    <Tab label={t`Timber Storages`} value="timberStorage"/>
                }
                { session.hasPermission('', 'applications/location/entities/Shipments/list/view') &&
                    <Tab label={t`Shipments`} value="shipment"/>
                }
                </Tabs>
            
            { session.hasPermission('', 'applications/location/entities/Locations/list/view') &&
                <TabPanel value={tabValue} index="location" data-testid="Location-tab">
                    <LocationListItem locationId={data?.id} showAdd={ true } />
                </TabPanel>
            }
            { session.hasPermission('', 'applications/location/entities/TimberStorages/list/view') &&
                <TabPanel value={tabValue} index="timberStorage" data-testid="TimberStorage-tab">
                    <TimberStorageListItem locationId={data?.id} showAdd={ false } />
                </TabPanel>
            }
            { session.hasPermission('', 'applications/location/entities/Shipments/list/view') &&
                <TabPanel value={tabValue} index="shipment" data-testid="Shipment-tab">
                    <ShipmentListItem locationId={data?.id} showAdd={ false } />
                </TabPanel>
            }
            
        </Box>
    )
}

export default LocationTabs;
